'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageFooterWrapper = styled.div.attrs(() => ({
  'data-test-id': 'primary-message-footer'
})).withConfig({
  displayName: "PrimaryMessageFooter__PrimaryMessageFooterWrapper",
  componentId: "j4lzo-0"
})(["display:flex;margin-top:4px;"]);
export default class PrimaryMessageFooter extends PureComponent {
  render() {
    const {
      children,
      className
    } = this.props;
    return /*#__PURE__*/_jsx(PrimaryMessageFooterWrapper, {
      className: className,
      children: children
    });
  }
}
PrimaryMessageFooter.displayName = 'PrimaryMessageFooter';
PrimaryMessageFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};